module.exports = __webpack_public_path__ + "static/img/SCW部件组成1-域控制器.cf2107e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3/SCW部件组成1-域控制器.png
// module id = 2p78
// module chunks = 0